// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@med/app/guards/auth.guard';
import { HomeRedirectGuard } from '@med/app/guards/home-redirect.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [HomeRedirectGuard],
    children: [],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./external-panel/external-panel.routes').then((m) => m.externalPanelRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./home/home.routes').then((m) => m.homeRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: '',
        loadChildren: () => import('./errors/errors.module').then((m) => m.ErrorsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
